"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.density = void 0;
var _intents = _interopRequireDefault(require("./intents"));
/**
 * density
 * Static object containing all pre-calculated density values for spacing
 * Based on intents.ux.box.density (0.25rem)
 * Uses string keys for numeric multiples to maintain Linaria compatibility
 */
/* eslint-disable quote-props */
const density = exports.density = {
  // For --fixed-space--400 (0.25rem) - multiple of 1
  '1': `${_intents.default.ux.box.density}`,
  // For --fixed-space--300 (0.5rem) - multiple of 2
  '2': `calc(${_intents.default.ux.box.density} * 2)`,
  // For --fixed-space--200 (0.75rem) - multiple of 3
  '3': `calc(${_intents.default.ux.box.density} * 3)`,
  // For --fixed-space--100 (0.875rem) - multiple of 3.5
  '3.5': `calc(${_intents.default.ux.box.density} * 3.5)`,
  // For --fixed-space-100 (1rem) - multiple of 4
  '4': `calc(${_intents.default.ux.box.density} * 4)`,
  // For --fixed-space-150 (1.25rem) - multiple of 5
  '5': `calc(${_intents.default.ux.box.density} * 5)`,
  // For --fixed-space-200 (1.5rem) - multiple of 6
  '6': `calc(${_intents.default.ux.box.density} * 6)`,
  // For --fixed-space-250 (1.75rem) - multiple of 7
  '7': `calc(${_intents.default.ux.box.density} * 7)`,
  // For --fixed-space-300 (2rem) - multiple of 8
  '8': `calc(${_intents.default.ux.box.density} * 8)`,
  // For --fixed-space-400 (2.5rem) - multiple of 10
  '10': `calc(${_intents.default.ux.box.density} * 10)`,
  // For --fixed-space-500 (3rem) - multiple of 12
  '12': `calc(${_intents.default.ux.box.density} * 12)`,
  // For --fixed-space-600 (3.5rem) - multiple of 14
  '14': `calc(${_intents.default.ux.box.density} * 14)`,
  // multiple of 16 (4rem)
  '16': `calc(${_intents.default.ux.box.density} * 16)`,
  // For --fixed-space-700 (4.5rem) - multiple of 18
  '18': `calc(${_intents.default.ux.box.density} * 18)`,
  // For --fixed-space-800 (6rem) - multiple of 24
  '24': `calc(${_intents.default.ux.box.density} * 24)`,
  // For --fixed-space-900 (7.5rem) - multiple of 30
  '30': `calc(${_intents.default.ux.box.density} * 30)`,
  // For --fixed-space-1000 (10rem) - multiple of 40
  '40': `calc(${_intents.default.ux.box.density} * 40)`
};